import { FieldHookConfig, useField } from 'formik';
import { Checkbox, CheckboxProps } from 'src/components/Checkbox';

interface FormCheckboxExtraProps {
  name: string;
}

type FormCheckboxProps = CheckboxProps &
  FormCheckboxExtraProps &
  FieldHookConfig<boolean>;

export const FormCheckbox: React.FC<FormCheckboxProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const { onChange } = props;

  return (
    <Checkbox
      {...field}
      checked={field.value}
      {...props}
      onChange={(event) => {
        setValue(event.target.checked);
        if (onChange) onChange(event, event.target.checked);
      }}
    />
  );
};
